import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import AuctionNotice from "./home/AuctionNotice";
import PublicationNotice from "./home/PublicationNoice";
import TenderNotice from "./home/TenderNotice";
import ActAndRuleParent from "../Acts/ActAndRuleParent";
import PublicNotice from "./home/PublicNotice";
import { useTitle } from "../../services/PageTitle";

const AllNotices = () => {
  useTitle("Notices");
  const [relatedLink, setRelatedLink] = useState("PublicNotice");

  return (
    <>
      <div className="about">
        <div className="inner-bg">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="b-title">
                  <h5>Notices</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="breadcrumb-bg">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/">Home</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Notices
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div className="tender-bg allnotice-sec">
          <div className="container">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <ul
                className="nav d-flex justify-content-center"
                id="pills-tab-btm"
                role="tablist"
                aria-label="Notice Categories"
              >
                <li className="nav-item" role="presentation">
                  <a
                    href="#"
                    role="tab"
                    id="auction-tab"
                    aria-controls="pills-auction"
                    aria-selected={relatedLink === "AuctionNotice"}
                    className={`nav-link ${
                      relatedLink === "AuctionNotice" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setRelatedLink("AuctionNotice");
                    }}
                  >
                    AUCTION NOTICE
                  </a>
                </li>

                <li className="nav-item" role="presentation">
                  <a
                    href="#"
                    role="tab"
                    id="publication-tab"
                    aria-controls="pills-pn"
                    aria-selected={relatedLink === "PublicationNotice"}
                    className={`nav-link ${
                      relatedLink === "PublicationNotice" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setRelatedLink("PublicationNotice");
                    }}
                  >
                    PUBLICATION NOTICE
                  </a>
                </li>

                <li className="nav-item" role="presentation">
                  <a
                    href="#"
                    role="tab"
                    id="tender-tab"
                    aria-controls="pills-tender"
                    aria-selected={relatedLink === "TenderNotice"}
                    className={`nav-link ${
                      relatedLink === "TenderNotice" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setRelatedLink("TenderNotice");
                    }}
                  >
                    TENDER NOTICE
                  </a>
                </li>

                <li className="nav-item" role="presentation">
                  <a
                    href="#"
                    role="tab"
                    id="public-tab"
                    aria-controls="pills-public"
                    aria-selected={relatedLink === "PublicNotice"}
                    className={`nav-link ${
                      relatedLink === "PublicNotice" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setRelatedLink("PublicNotice");
                    }}
                  >
                    PUBLIC NOTICE
                  </a>
                </li>
              </ul>

              <div className="tab-content notices-sec" id="pills-tabContent">
                {relatedLink === "AuctionNotice" && (
                  <div
                    className="tab-pane fade show active"
                    id="pills-auction"
                    role="tabpanel"
                    aria-labelledby="auction-tab"
                  >
                    <AuctionNotice />
                  </div>
                )}

                {relatedLink === "PublicationNotice" && (
                  <div
                    className="tab-pane fade show active"
                    id="pills-pn"
                    role="tabpanel"
                    aria-labelledby="publication-tab"
                  >
                    <PublicationNotice />
                  </div>
                )}

                {relatedLink === "TenderNotice" && (
                  <div
                    className="tab-pane fade show active"
                    id="pills-tender"
                    role="tabpanel"
                    aria-labelledby="tender-tab"
                  >
                    <TenderNotice />
                  </div>
                )}

                {relatedLink === "PublicNotice" && (
                  <div
                    className="tab-pane fade show active"
                    id="pills-public"
                    role="tabpanel"
                    aria-labelledby="public-tab"
                  >
                    <PublicNotice />
                  </div>
                )}

                {/* fallback - Acts & Rules */}
                {relatedLink !== "AuctionNotice" &&
                  relatedLink !== "PublicationNotice" &&
                  relatedLink !== "TenderNotice" &&
                  relatedLink !== "PublicNotice" && (
                    <div
                      className="tab-pane fade show active"
                      id="pills-fallback"
                      role="tabpanel"
                      aria-labelledby="publication-tab"
                    >
                      <ActAndRuleParent />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllNotices;
